import i18next, { TFunction } from 'i18next'
import { ILangsAvailable } from './interface'

export const availableLanguages = (): ILangsAvailable[] => {
  const T: TFunction = i18next.t.bind(i18next)
  return [
    { default: true, label: T('languages.es'), value: 'es' },
    { default: false, label: T('languages.en'), value: 'en' }
  ]
}
